import React, { Fragment, useEffect, useState } from 'react';
import { Card, Grid, Typography } from '@mui/material';
import Completion from './components/Completion';
import Versions from './components/Versions';
import { getHealthSummary } from 'src/services/projectService';

const ProjectHealthView = () => {
  const [selectedProject, setSelectedProject] = useState('');
  const [summary, setSummary] = useState<any>(null);

  const getSummary = (name) => {
    getHealthSummary(name).then((res) => {
      setSummary(res?.data[0]);
    });
  };

  useEffect(() => {
    if (!summary) getSummary(selectedProject);
  }, [selectedProject, summary]);

  const colorBoxes = [
    {
      title: 'In Progress',
      miniTitle: 'Delivery Status',
      color: '#FFC107'
    },
    {
      title: 'Approved',
      miniTitle: 'SOW',
      color: '#00B26A'
    },
    {
      title: 'PO Received',
      miniTitle: 'Payment Note',
      color: '#00B26A'
    }
  ];
  return (
    <Fragment>
      <Grid container sx={{ mt: 5, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            Project Health Summary
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 2, mb: 2 }}>
        <Grid xs={3}>
          <Completion summary={summary} />
          {colorBoxes.map((box) => (
            <Card
              style={{
                marginTop: '1.75rem',
                padding: '0.5rem',
                borderLeft: `3px solid ${box.color}`,
                borderRadius: '4px'
              }}
            >
              <Typography
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  pb: 1,
                  fontSize: '21px',
                  fontWeight: '600',
                  color: '#5B5B5B'
                  // borderBottom: `3px solid ${box.color}`
                }}
              >
                {box.title}
              </Typography>
              <Grid
                style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <div
                  style={{
                    width: '15%',
                    height: '3px',
                    borderBottom: `5px solid ${box.color}`,
                    borderRadius: '5px'
                  }}
                />
              </Grid>
              <Typography
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  pt: 1,
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#202020'
                }}
              >
                {box.miniTitle}
              </Typography>
            </Card>
          ))}
        </Grid>
        <Grid item xs={9} style={{ paddingLeft: '1rem' }}>
          <Versions
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            summary={summary}
            getSummary={getSummary}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default ProjectHealthView;
